const data = {
  title: '¿A dónde enviamos tus productos?',
};

export default data;
